import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { orderStatus, orderStatusFormatted } from "src/constant";
import OrderUnsuccessfulDialog from "./OrderUnsuccessfulDialog";
import useAppGlobal from "src/context/useAppGlobal";
import ConfirmComp from "src/components/shared/ConfirmComp";
import useOrderTrackingStatus from "src/hooks/orders/useOrderTrackingStatus";
import { enqueueSnackbar } from "notistack";
import PrepareOrderDialog from "./PrepareOrderDialog";
import OrderReturnRefundDialog from "./OrderReturnRefundDialog";
import OrderReturnDialog from "./OrderReturnDialog";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

const nowrap = { whiteSpace: "nowrap", fontSize: "12px" };
export default function OrderActionGroup({ item, mutate }) {
  const permissionCheck = useRoleCheck();
  const { closeDialog, handleOpenDialog } = useAppGlobal();
  const { trigger: changeStatus } = useOrderTrackingStatus();

  const handleChooseType = () => {
    handleOpenDialog({
      title: "Lý do giao hàng không thành công",
      content: (
        <OrderUnsuccessfulDialog
          item={item}
          mutate={mutate}
        />
      ),
      size: "sm",
    });
  };

  const handleOrderConfirm = async (id, status) => {
    const res = await changeStatus({
      pathIncluded: {
        orderId: id,
      },
      body: {
        trackingStatus: [orderStatusFormatted.ReturnedWaitToCheck, orderStatusFormatted.Canceled, orderStatusFormatted.Returning]?.includes(status) ? status : orderStatus[status],
        warehouse: item?.warehouse,
      },
    });
    if (res?.success) {
      closeDialog();
      mutate();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Lỗi khi xác nhận đơn hàng", { variant: "error" });
    }
  };

  const handleCheckReturnProd = () => {
    handleOpenDialog({
      title: "Kiểm tra và xác nhận đã trả hàng",
      content: (
        <OrderReturnDialog
          check={"check"}
          item={item}
          mutate={mutate}
        />
      ),
      size: "xl",
    });
  };

  const handleOpenReturnRefund = () => {
    handleOpenDialog({
      title: "Xác nhận Đơn hàng Đổi/ Trả hàng",
      content: (
        <OrderReturnRefundDialog
          item={item}
          mutate={mutate}
        />
      ),
      size: "xl",
    });
  };
  const action = () => {
    // eslint-disable-next-line default-case
    switch (item?.trackingStatus) {
      case orderStatusFormatted.Delivering:
        return (
          <Box
            gap="6px"
            sx={{ display: "flex", justifyContent: "center", m: "0 auto" }}
          >
            <Button
              disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
              onClick={() =>
                handleOpenDialog({
                  content: (
                    <ConfirmComp
                      custom={{
                        label: "Vui lòng xác nhận đã giao hàng thành công.",
                        action: "Confirm",
                      }}
                      onConfirm={() =>
                        handleOrderConfirm(item?._id, item?.trackingStatus === orderStatusFormatted.Returning ? orderStatusFormatted.ReturnedWaitToCheck : item?.trackingStatus)
                      }
                    />
                  ),
                  size: "md",
                })
              }
              sx={{ ...nowrap }}
              variant="contained"
              size="small"
            >
              Giao TC
            </Button>
            <Button
              disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
              sx={{ ...nowrap }}
              variant="outlined"
              size="small"
              onClick={handleChooseType}
            >
              Giao không TC
            </Button>
          </Box>
        );
      case orderStatusFormatted.ReturnedWaitToCheck:
        return (
          <Button
            disabled={!permissionCheck([PERMISSIONS.PROCESSRETURNORDER_ORDER_ALL, PERMISSIONS.PROCESSRETURNORDER_ORDER_OWN])}
            size="small"
            variant="contained"
            sx={{ ...nowrap, display: "flex", m: "0 auto" }}
            onClick={handleCheckReturnProd}
          >
            Kiểm tra
          </Button>
        );
      case orderStatusFormatted.WaitToExport:
        return (
          <Box sx={{ display: "flex", justifyContent: "center", m: "0 auto", gap: "6px" }}>
            <Button
              disabled={!permissionCheck([PERMISSIONS.PREPARE_ORDER_ALL, PERMISSIONS.PREPARE_ORDER_OWN])}
              sx={{ ...nowrap }}
              onClick={() =>
                handleOpenDialog({
                  title: "Xác nhận và chuẩn bị đơn hàng",
                  content: (
                    <PrepareOrderDialog
                      item={item}
                      mutate={mutate}
                    />
                  ),
                  size: "xl",
                })
              }
              size="small"
              variant="contained"
            >
              Soạn hàng
            </Button>
            <Button
              sx={{ ...nowrap }}
              disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
              onClick={() =>
                handleOpenDialog({
                  content: (
                    <ConfirmComp
                      custom={{
                        label: "Xác nhận hủy đơn hàng.",
                        // action: "Confirm",
                      }}
                      onConfirm={() => handleOrderConfirm(item?._id, orderStatusFormatted.Canceled)}
                    />
                  ),
                  size: "md",
                })
              }
              size="small"
              variant="outlined"
            >
              Huỷ
            </Button>
          </Box>
        );
      case orderStatusFormatted.WaitToProcess:
      case orderStatusFormatted.ReadyToPick:
        return (
          <Box sx={{ display: "flex", justifyContent: "center", m: "0 auto", gap: "6px" }}>
            <Button
              disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
              onClick={() =>
                handleOpenDialog({
                  content: (
                    <ConfirmComp
                      custom={{
                        label: "Xác nhận đơn hàng đã giao cho đơn vị vận chuyển.",
                        action: "Confirm",
                      }}
                      onConfirm={() =>
                        handleOrderConfirm(item?._id, item?.trackingStatus === orderStatusFormatted.Returning ? orderStatusFormatted.ReturnedWaitToCheck : item?.trackingStatus)
                      }
                    />
                  ),
                  size: "md",
                })
              }
              sx={{ ...nowrap }}
              variant="contained"
              size="small"
            >
              Xác nhận
            </Button>
            {item?.trackingStatus === orderStatusFormatted.ReadyToPick && (
              <Button
                disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
                onClick={() =>
                  handleOpenDialog({
                    content: (
                      <ConfirmComp
                        custom={{
                          label: "Xác nhận hoàng hàng",
                        }}
                        onConfirm={() => handleOrderConfirm(item?._id, orderStatusFormatted.Returning)}
                      />
                    ),
                    size: "md",
                  })
                }
                sx={{ ...nowrap }}
                variant="outlined"
                size="small"
              >
                Hoàn hàng
              </Button>
            )}
          </Box>
        );
      case orderStatusFormatted.DeliveredFailed:
        return (
          <Button
            disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
            variant="contained"
            size="small"
            sx={{ ...nowrap, display: "flex", m: "0 auto" }}
            onClick={() =>
              handleOpenDialog({
                content: (
                  <ConfirmComp
                    custom={{
                      label: "Vui lòng xác nhận đã giao hàng thành công.",
                      action: "Confirm",
                    }}
                    onConfirm={() =>
                      handleOrderConfirm(item?._id, item?.trackingStatus === orderStatusFormatted.Returning ? orderStatusFormatted.ReturnedWaitToCheck : item?.trackingStatus)
                    }
                  />
                ),
                size: "md",
              })
            }
          >
            Xác nhận hoàn về
          </Button>
        );
      case orderStatusFormatted.Returning:
        return (
          <Button
            disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN])}
            size="small"
            variant="contained"
            sx={{ ...nowrap, display: "flex", justifyContent: "center", m: "0 auto" }}
            onClick={() =>
              handleOpenDialog({
                content: (
                  <ConfirmComp
                    custom={{
                      label: "Xác nhận đã nhận lại kiện hàng.",
                      action: "Confirm",
                    }}
                    onConfirm={() =>
                      handleOrderConfirm(item?._id, item?.trackingStatus === orderStatusFormatted.Returning ? orderStatusFormatted.ReturnedWaitToCheck : item?.trackingStatus)
                    }
                  />
                ),
                size: "md",
              })
            }
          >
            Nhận hàng tiến hành kiểm tra
          </Button>
        );
      case orderStatusFormatted.Delivered:
        return (
          <Button
            disabled={!permissionCheck([PERMISSIONS.CHANGESTATUS_ORDER_ALL, PERMISSIONS.CHANGESTATUS_ORDER_OWN] || !!item?.currentSubOrder)}
            sx={{ ...nowrap, display: "flex", m: "0 auto" }}
            onClick={handleOpenReturnRefund}
            variant="contained"
            size="small"
          >
            Đổi/ Trả hàng
          </Button>
        );
      case orderStatusFormatted.Lost:
        return (
          <Typography
            variant="body2"
            sx={{ color: "var(--error)", textAlign: "center" }}
          >
            Đơn hàng thất lạc
          </Typography>
        );
      case orderStatusFormatted.Returned:
        return (
          <Typography
            textAlign="center"
            variant="body2"
            color="success"
          >
            Nhận hàng trả thành công
          </Typography>
        );
      case orderStatusFormatted.Canceled:
        return (
          <Typography
            textAlign="center"
            variant="body2"
            color="error"
          >
            Hủy giao hàng
          </Typography>
        );
    }
  };
  return action();
}
